import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance"
import { IDashboardSummaryDaily, IDashboardSummary, IDashboardSummaryTotal } from "../../application/models"

export const useDashboardSummaryApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getDashboardSummaryDataApi = useCallback(async (): Promise<{
        daily: {
            dailySummary: IDashboardSummaryDaily
            topClientes: IDashboardSummary[]
            topUsuarios: IDashboardSummary[]
            topProdutos: IDashboardSummary[]
            topVariaveis: IDashboardSummary[]
            consultaPorTipoConsumo_1: IDashboardSummary
            consultaPorTipoConsumo_2: IDashboardSummary
            consultaPorTipoConsumo_3: IDashboardSummary
            consultaPorTipoConsumo_4: IDashboardSummary
            consultaPorTipoConsumo_5: IDashboardSummary
            consultaPorTipoConsumo_6: IDashboardSummary
            consultaPorTipoConsumo_7: IDashboardSummary
            consultaPorTipoConsumo_8: IDashboardSummary
            consultaPorTipoConsumo_9: IDashboardSummary
            consultaPorTipoConsumo_Outros: IDashboardSummary
        }
        total: {
            totalSummary: IDashboardSummaryTotal
            topClientes: IDashboardSummary[]
            topUsuarios: IDashboardSummary[]
            topProdutos: IDashboardSummary[]
            topVariaveis: IDashboardSummary[]
            consultaPorUsuario_1: IDashboardSummary
            consultaPorUsuario_2: IDashboardSummary
            consultaPorUsuario_3: IDashboardSummary
            consultaPorUsuario_4: IDashboardSummary
            consultaPorUsuario_5: IDashboardSummary
            consultaPorUsuario_6: IDashboardSummary
            consultaPorUsuario_7: IDashboardSummary
            consultaPorUsuario_8: IDashboardSummary
            consultaPorUsuario_9: IDashboardSummary
            consultaPorUsuario_Outros: IDashboardSummary
        }
    }> => {
        try {
            const result = await axiosAuthInstance.get('/home')

            return {
                daily: result.data.daily,
                total: result.data.total
            }
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])

    return {
        getDashboardSummaryDataApi
    }
}